
import React, {
   useState,
    useEffect,
     useContext,
     useRef,
     } from 'react';
import { Field, Form } from 'react-final-form';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Col } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap,
} from '@/shared/components/Card';
import { CiCirclePlus } from 'react-icons/ci';
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import { parseISO } from 'date-fns';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
} from '@/shared/components/form/FormElements';
import renderSelectField from '@/shared/components/form/Select';
import DatePicker from 'react-datepicker';
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import { Button } from '@/shared/components/Button';
import { IoIosRemoveCircle } from 'react-icons/io';
import PropTypes from 'prop-types';
import { Table } from '@/shared/components/TableElements';
import toast from 'react-hot-toast';
import { Mealcontext } from '../../../../context/MealContext';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';
import { AuthContext } from '../../../../context/AuthContext';


const AddEditMeal = ({ 
  onSubmit, 
  id,
  loading,
}) => {
  const {
    meals,
    setMeals,
  } = useContext(Mealcontext);
  const { apiGlobal } = useContext(GlobalVarContext);
  const { userid, countryId } = useContext(AuthContext);

  const [prevData, setPrevData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
   const [fetchLocationName, setFetchLocationName] = useState([]);
  const [LocationsNames, setLocationsNames] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
 const [endDate, setEndDate] = useState(new Date());
  const selectRef = useRef(null);



  // fetch location Option in Intial Mount Component ✅16-12-2024
  const fetchLocationOptionOnInitialMount = async (value) => {
    const formData = new FormData();
    formData.append('type', 2);
    formData.append('id', value);
    formData.append('user_id', userid);
    formData.append('country_id', countryId);

    try {
      const url = await fetch(`${apiGlobal}/restaurant_data_load.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
      // console.log(response);
      
      if (response.status && response.message === 'Success') {
        setFetchLocationName(response.data.map(item => ({
          value: item.id,
          label: item.restaurant_name,
        })));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const convertDateFormat = (dateString) => {
    // Check if the date string uses '/' or '-'
    const separator = dateString.includes('/') ? '/' : '-';
  
    // Split the string based on the separator
    const parts = dateString.split(separator);
    const [day, month, year] = separator === '/' ? parts : [parts[0], parts[1], parts[2]];
    return `${year}-${month}-${day}`;
  };


  useEffect(() => {
    if (!id) return; // Early return if `id` is not available
  
    // Declare an async function inside useEffect
    async function fetchDataForEdit() {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('country_id', countryId);
      try {
        const fetchMeal = await fetch(`${apiGlobal}/meal_data_fetch.php`, {
          method: 'POST',
          body: formData,
        });
        const res = await fetchMeal.json();
  
        if (res.status && res.message === 'Success') {
          const mealData = res.data[0];

          const formattedStartDate = convertDateFormat(mealData.start_date); 
          const formattedEndDate = convertDateFormat(mealData.end_date); 

          // console.log(formattedStartDate);
          // console.log(formattedEndDate);
          const parsedStartDate = parseISO(formattedStartDate); 
           const parsedEndDate = parseISO(formattedEndDate); 


           setStartDate(parsedStartDate); 
           setEndDate(parsedEndDate);

          setPrevData({ ...mealData, start_date: parsedStartDate, end_date: parsedEndDate });
          fetchLocationOptionOnInitialMount(mealData.restaurant_id);
         
          setLocationsNames(
            res.data[0].locations.map(location => ({
              value: location.location_id,
              label: location.location_name,
            })),
          );
          
  
          try {
            const itemsArray = JSON.parse(mealData.items);
            setMeals(itemsArray);
          } catch (e) {
            toast.error('Failed to parse meal items.');
          }
  
          if (mealData.photo) {
            setSelectedImage(`${apiGlobal}/images/meal/${mealData.photo}`);
          }
        } else {
          toast.error('Failed to fetch meal data for edit.');
        }
      } catch (error) {
        toast.error(`Failed to fetch: ${error.message}`);
      }
    }
  
    fetchDataForEdit();
  }, [id]);



  // useEffect(() => {
  //   let isMounted = true;

  //   const fetchRestaurant = async () => {
  //       try {
  //         const response = await fetch(`${apiGlobal}/restaurant_data_load.php?type=1`);
  //         if (!response.ok) {
  //           throw new Error(`HTTP error! status: ${response.status}`);
  //         }
  //         const data = await response.json();
  //         if (data.status && data.message === 'Success') {
  //           if (isMounted) {
  //             setFetchRestaurantName(data.data.map(item => (
  //               { value: item.restaurant_id, label: item.restaurant_name })));
  //           }
  //         }
  //       } catch (error) {
  //         console.error('There has been a problem with your fetch operation:', error);
  //       }
  //     };

  //   fetchRestaurant();

  //   return () => {
  //     isMounted = false;
  //   };
  // }, []);


  const handleFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelectedImage(null);
      input.onChange(null);
    }
  };

  const handleAddMeal = (values) => {
    const newMeal = {
      item_id: meals.length + 1,
      name: values.Item,
      description: values.desc,
    };
    setMeals(prevMeals => [...prevMeals, newMeal]);
  };


  const getMealOfferedChecked = (mealOffered, type) => {
    const mealMap = {
      breakfast: 1,
      Snacks: 2,
      lunch: 3,
      dinner: 4,
    };

    return mealOffered && mealOffered.includes(mealMap[type]);
  };

  const getMealFormatChecked = (mealFormat, type) => {
    const mealMap = {
      1: 'fit',
      2: 'git',
      3: 'delivery',
    };

    return mealFormat && mealMap[mealFormat] === type;
  };

  const getMealvegChecked = (mealveg, type) => {
    const mealMap = {
      1: 'veg',
      2: 'nonveg',
      3: 'vegNonveg',
    };

    return mealveg && mealMap[mealveg] === type;
  };
  

  // function for load location after every restaurant OnChnage
  // const handleSelectoptionChange = async (option) => {
  //   if (selectRef.current) {
  //         selectRef.current.select.setValue([]);
  //       }

  //   setSelectRestaurant(option);
  //   setRestaurantSelectOption(option);
  //   if (option.value) {
  //         try {
  //           const url = await fetch(`${apiGlobal}/restaurant_data_load.php?
  //             type=2&id=${option.value}`);
  //           const response = await url.json();
  //           if (response.status && response.message === 'Success') {
  //             setFetchLocationName(response.data.map(item => ({ value: item.id, label: item.restaurant_name })));
  //           }
  //           } catch (error) {
  //           console.log(error);
  //         }
  //       } else {
  //         console.error('No restaurant Select');
  //       }
  // };

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>

          </CardTitleWrap>
          {prevData ? ( 
            <Form onSubmit={onSubmit} initialValues={prevData}>
              {({ handleSubmit, form }) => (
                <FormContainer onSubmit={handleSubmit}>
                  <FormHalfContainer>
                    <FormGroup>
                      <FormGroupLabel>Select Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <Field
                        name="locationsid"
                        render={({ input }) => (
                          <Select
                            {...input}
                            name="locationsid"
                            ref={selectRef}
                            components={makeAnimated}
                            className="react-select"
                            classNamePrefix="react-select"
                            isMulti
                            value={LocationsNames} 
                            options={fetchLocationName}
                            onChange={(selected) => {
                              setLocationsNames(selected); 
                              input.onChange(selected);
                            }}
                            isClearable 
                            placeholder="Select a Location"
                            required
                          />
                        )}
                        
                      />
                    </FormGroup>



                    <FormGroup>
                      <FormGroupLabel>Meal Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="id"
                          component="input"
                          type="number"
                          placeholder="UID"
                          style={{ display: 'none' }}
                        />
                        <Field
                          name="name"
                          component="input"
                          type="text"
                          placeholder="Meal Name"
                          required
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>Meal Price<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="price"
                          component="input"
                          type="number"
                          placeholder="Meal Price"
                          required
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>FOC<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="foc"
                          component="input"
                          type="text"
                          placeholder="Foc"
                          className="w-60"
                          required
                        />
                        {' '}on
                        <Field
                          name="foc_on"
                          component="input"
                          type="text"
                          placeholder="Foc on"
                          className="w-60"
                          required
                        />
                      </FormGroupField>
                    </FormGroup>

                    {/* Meal Items Table */}
                    <FormGroup>
                      <Table responsive hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Description</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {meals.map((meal, index) => (
                            <tr key={meal.id}>
                              <td>{index + 1}</td>
                              <td>{meal.name}</td>
                              <td>{meal.description}</td>
                              <td>
                                <Button 
                                  type="button"
                                  variant="outline-danger" 
                                  size="sm"
                                  className="mt-2"
                                  onClick={() => setMeals(meals.filter(m => m.id !== meal.id))}
                                >
                                  <IoIosRemoveCircle />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th>
                              <FormGroupLabel>Item</FormGroupLabel>
                              <Field
                                name="Item"
                                component="input"
                                type="text"
                                placeholder="Item"
                              />
                            </th>
                            <th>
                              <FormGroupLabel>Description</FormGroupLabel>
                              <Field
                                name="desc"
                                component="input"
                                type="text"
                                placeholder="Description"
                              />
                            </th>
                            <th>
                              <Button
                                type="button"
                                variant="outline-success"
                                rounded
                                size="sm"
                                style={{ marginTop: '45px' }}
                                onClick={() => {
                                  // Collect the field values using React Final Form's form API
                                  const itemValue = document.querySelector('[name="Item"]').value;
                                  const descValue = document.querySelector('[name="desc"]').value;

                                  // Add meal item
                                  handleAddMeal({
                                    Item: itemValue,
                                    desc: descValue,
                                  });

                                  // Clear the form fields using form.change
                                  form.change('Item', '');
                                  form.change('desc', '');
                                }}
                              >
                                <CiCirclePlus />
                              </Button>
                            </th>
                          </tr>
                        </tfoot>

                      </Table>
                    </FormGroup>

                    {/* Meal Offered Checkboxes */}
                    <FormGroup>
                      <FormGroupLabel>Meal Offered</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="breakfast"
                          type="checkbox"
                          component={renderCheckBoxField}
                          label="Breakfast"
                          initialValue={getMealOfferedChecked(prevData.meal_offered, 'breakfast')}
                        />
                        <Field
                          name="Snacks"
                          type="checkbox"
                          component={renderCheckBoxField}
                          label="Snacks"
                          initialValue={getMealOfferedChecked(prevData.meal_offered, 'Snacks')}
                        />
                        <Field
                          name="lunch"
                          type="checkbox"
                          component={renderCheckBoxField}
                          label="Lunch"
                          initialValue={getMealOfferedChecked(prevData.meal_offered, 'lunch')}
                        />
                        <Field
                          name="dinner"
                          type="checkbox"
                          component={renderCheckBoxField}
                          label="Dinner"
                          initialValue={getMealOfferedChecked(prevData.meal_offered, 'dinner')}
                        />
                      </FormGroupField>
                    </FormGroup>

                    {/* Additional Fields */}
                    <FormGroup>
                      <FormGroupLabel>Meal format</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="format"
                          component={renderRadioButtonField}
                          label="Fit"
                          radioValue="1"
                          initialValue={getMealFormatChecked(prevData?.meal_format, 'fit') ? '1' : undefined}
                        />
                        <Field
                          name="format"
                          component={renderRadioButtonField}
                          label="Git"
                          radioValue="2"
                          initialValue={getMealFormatChecked(prevData?.meal_format, 'git') ? '2' : undefined}
                        />
                        <Field
                          name="format"
                          component={renderRadioButtonField}
                          label="Delivery"
                          radioValue="3"
                          initialValue={getMealFormatChecked(prevData?.meal_format, 'delivery') ? '3' : undefined}
                        />
                      </FormGroupField>
                    </FormGroup>

                    {/* Veg/Non-veg Radio Buttons */}
                    <FormGroup>
                      <FormGroupLabel>Veg/Non-veg</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="veg"
                          component={renderRadioButtonField}
                          label="Veg"
                          radioValue="1"
                          initialValue={getMealvegChecked(prevData?.veg_non_veg, 'veg') ? '1' : undefined}
                        />
                        <Field
                          name="veg"
                          component={renderRadioButtonField}
                          label="Non-veg"
                          radioValue="2"
                          initialValue={getMealvegChecked(prevData?.veg_non_veg, 'nonveg') ? '2' : undefined}
                        />
                        <Field
                          name="veg"
                          component={renderRadioButtonField}
                          label="Veg/Non-veg"
                          radioValue="3"
                          initialValue={getMealvegChecked(prevData?.veg_non_veg, 'vegNonveg') ? '3' : undefined}
                        />
                      </FormGroupField>
                    </FormGroup>

                    {/* Cuisines */}
                    <FormGroup>
                      <FormGroupLabel>Cuisines<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="cuisines"
                          component="input"
                          type="text"
                          placeholder="Cuisines"
                          required
                        />
                      </FormGroupField>
                    </FormGroup>

                    {/* Meal type */}
                    <FormGroup>
                      <FormGroupLabel>Meal type<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="meal_type"
                          component="input"
                          type="text"
                          placeholder="Meal Type"
                          required
                        />
                      </FormGroupField>
                    </FormGroup>
                  </FormHalfContainer>

                  {/* File Upload, Date Picker and Markup Percentage */}
                  <FormHalfContainer>
                    <FormGroup>
                      <FormGroupLabel>Description</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="description"
                          component="textarea"
                          placeholder="Description"
                        />
                      </FormGroupField>
                    </FormGroup>

                    <FormGroup>
                      <FormGroupLabel>Logo</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="logo"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handleFileChange(e, input)}
                            />
                          )}
                        />
                      </FormGroupField>
                    </FormGroup>

                    {selectedImage && (
                      <FormGroup>
                        <FormGroupLabel>Selected Logo</FormGroupLabel>
                        <FormGroupField>
                          <img
                            src={selectedImage}
                            alt="Selected Logo"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                          />
                        </FormGroupField>
                      </FormGroup>
                    )}

                    <FormGroup>
                      <FormGroupLabel>
                        Start Date<span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="start_date"
                          render={({ input }) => (
                            <DatePicker
                              {...input}
                              dateFormat="dd-MM-yyyy"
                              selected={startDate || input.value} 
                             // onChange={date => input.onChange(date)} 
                             // selected={startDate}
                              onChange={date => setStartDate(date)}
                              value={startDate}
                            />
     )}
                          initialValue={startDate}
                        />
                      </FormGroupField>
                    </FormGroup>

                    <FormGroup>
                      <FormGroupLabel>
                        End Date<span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="end_date"
                          render={({ input }) => (
                            <DatePicker
                              {...input}
                              dateFormat="dd-MM-yyyy"
                              selected={endDate || input.value} 
                             // onChange={date => input.onChange(date)} 
                             // selected={endDate} 
                              onChange={date => setEndDate(date)}
                              value={endDate}
                            />
     )}
                          initialValue={endDate}
                        />
                      </FormGroupField>
                    </FormGroup> 

                    {/* <FormGroup>
                      <FormGroupLabel>Start Date</FormGroupLabel>
                      <FormGroupField className="priority">
                        <Field
                          name="start_date"
                          type="text"
                          dueDate={dueDate.startDate}
                          component={renderDatePicker}
                          required
                        />
                      </FormGroupField>
                    </FormGroup> */}
                    {/* <FormGroup>
                      <FormGroupLabel>Start Date</FormGroupLabel>
                      <FormGroupField>
                      <DatePicker
      value={dueDate.StartDate} // Use value instead of defaultValue
      format="DD/MM/YYYY"
      onChange={(date) => setDueDate({ ...dueDate, StartDate: date })}
      getPopupContainer={(trigger) => trigger.parentNode}
    />      


                      </FormGroupField>
                    </FormGroup> */}

                    {/* <FormGroup>
                      <FormGroupLabel>
                        Start Date<span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="start_date"
                          render={({ input }) => (
                            <DatePicker
                              {...input}
                              onChange={date => input.onChange(date)}
                              dateFormat="dd-MM-yyyy"
                              selected={input.value ? parseISO(input.value) : parseISO(dueDate.startDate)}
                              value={input.value ? input.value : parseISO(dueDate.startDate)}
                            />
                          )}
                        
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>
                        End Date<span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="end_date"
                          render={({ input }) => (
                            <DatePicker
                              {...input}
                              onChange={date => input.onChange(date)}
                              dateFormat="dd-MM-yyyy"
                              selected={input.value ? parseISO(input.value) : parseISO(dueDate.endDate)}
                              value={input.value ? input.value : parseISO(dueDate.endDate)}
                            />
                          )}
                        />
                      </FormGroupField>
                    </FormGroup> */}


                    {/* <FormGroup>
                      <FormGroupLabel>Start Date</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="start_date"
                          component={renderDatePickerField}
                          type="date"
                          placeholder="Start Date"
                        />
                      </FormGroupField>
                    </FormGroup>

                    <FormGroup>
                      <FormGroupLabel>End Date</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="end_date"
                          component={renderDatePickerField}
                          type="date"
                          placeholder="End Date"
                        />
                      </FormGroupField>
                    </FormGroup> */}

                    <FormGroup>
                      <FormGroupLabel>Markup Percentage<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="markup_percentage"
                          component="input"
                          type="number"
                          disabled
                          placeholder="Markup Percentage"
                          required
                        />
                      </FormGroupField>
                    </FormGroup>

                    <FormButtonToolbar>
                      <Button disabled={loading} variant="primary" type="submit">
                        Submit
                      </Button>
                      {/* <Button variant="secondary" type="button">
                        Reset
                      </Button> */}
                    </FormButtonToolbar>
                  </FormHalfContainer>
                </FormContainer>
              )}
            </Form>
          ) : (
            <p>Loading data...</p> 
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

AddEditMeal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  setRestaurantSelectOption: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default AddEditMeal;
